(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const initCartForm = () => {
    const form = document.getElementById('CartForm');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    // Avec JavaScript, la quantité est mise à jour automatiquement :
    // le bouton « Mettre à jour » n'est utile que sans JavaScript.
    document.documentElement.classList.add('js-enabled');
    let timer;
    form.addEventListener('change', (event) => {
      if (!event.target.matches('[data-cart-qty]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        const update = form.querySelector('[data-cart-update]');
        if (form.requestSubmit && update) {
          form.requestSubmit(update);
        } else {
          form.submit();
        }
      }, 400);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartForm);
  } else {
    initCartForm();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // Ferme le menu mobile après un clic sur un lien ou avec la touche Échap.
    document.addEventListener('click', (event) => {
      const nav = document.querySelector('[data-mobile-nav][open]');
      if (!nav) return;
      if (event.target.closest('.mobile-nav__panel a') || !nav.contains(event.target)) {
        nav.removeAttribute('open');
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const nav = document.querySelector('[data-mobile-nav][open]');
      if (nav) {
        nav.removeAttribute('open');
        nav.querySelector('summary').focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('vt-product-gallery')) {
    customElements.define(
      'vt-product-gallery',
      class VtProductGallery extends HTMLElement {
        connectedCallback() {
          this.viewer = this.querySelector('[data-viewer]');
          this.thumbs = Array.from(this.querySelectorAll('.product__thumb'));
          if (!this.viewer) return;

          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => this.show(thumb.dataset.target));
          });

          // Met à jour la vignette active pendant le glissement
          if (this.thumbs.length && 'IntersectionObserver' in window) {
            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) this.setActive(entry.target.dataset.mediaId);
                });
              },
              { root: this.viewer, threshold: 0.6 }
            );
            this.viewer.querySelectorAll('[data-media-id]').forEach((slide) => observer.observe(slide));
          }
        }

        show(mediaId) {
          const slide = this.viewer.querySelector(`[data-media-id="${mediaId}"]`);
          if (!slide) return;
          this.viewer.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          this.setActive(mediaId);
        }

        setActive(mediaId) {
          this.thumbs.forEach((thumb) => {
            if (thumb.dataset.target === String(mediaId)) {
              thumb.setAttribute('aria-current', 'true');
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  if (!customElements.get('vt-product-form')) {
    customElements.define(
      'vt-product-form',
      class VtProductForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form.product__form');
          this.select = this.querySelector('[data-variant-select]');
          this.quantity = this.querySelector('.quantity__input');
          this.submitButtons = Array.from(this.querySelectorAll('[data-submit]'));
          this.errorBox = this.querySelector('[data-error]');
          this.stickyBar = this.querySelector('[data-sticky-bar]');
          this.submitting = false;

          this.querySelectorAll('[data-qty]').forEach((button) => {
            button.addEventListener('click', () => this.stepQuantity(parseInt(button.dataset.qty, 10)));
          });

          if (this.select) {
            this.select.addEventListener('change', () => this.onVariantChange());
          }

          if (this.form) {
            this.form.addEventListener('submit', (event) => this.onSubmit(event));
          }

          this.setupStickyBar();
          this.watchEasySell();
          this.watchEasySellSticky();
        }

        // Bouton fixe d'EasySell (#es-sticky) : style VOLTEO (pilule couleur d’accent légèrement
        // décollée du bas) et retrait de la barre fixe du thème pour éviter le doublon.
        watchEasySellSticky() {
          const apply = (sticky) => {
            const wanted = {
              background: 'var(--color-button)',
              color: 'var(--color-on-accent)',
              'border-radius': 'var(--style-border-radius-buttons)',
              'border-width': '0px',
              'font-weight': '700',
              left: '12px',
              right: '12px',
              width: 'auto',
              bottom: 'calc(12px + env(safe-area-inset-bottom))',
              'min-height': '3.25rem',
              'box-shadow': '0 10px 28px color-mix(in srgb, var(--color-dark) 28%, transparent)',
            };
            Object.entries(wanted).forEach(([property, value]) => {
              if (sticky.style.getPropertyValue(property) !== value || sticky.style.getPropertyPriority(property) !== 'important') {
                sticky.style.setProperty(property, value, 'important');
              }
            });
            sticky.querySelectorAll('span, i').forEach((el) => {
              if (el.style.getPropertyValue('color') !== 'var(--color-on-accent)') el.style.setProperty('color', 'var(--color-on-accent)', 'important');
            });
            sticky.classList.add('vt-es');
            document.body.classList.add('has-es-sticky');
          };
          // Le bouton fixe se cache quand un bouton « Commander » (EasySell) ou le pied
          // de page est visible à l'écran, et réapparaît ensuite.
          const visible = new Set();
          const refresh = () => {
            const sticky = document.getElementById('es-sticky');
            if (sticky) sticky.classList.toggle('vt-es-hidden', visible.size > 0);
          };
          const visibility = 'IntersectionObserver' in window
            ? new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) visible.add(entry.target);
                  else visible.delete(entry.target);
                });
                refresh();
              }, { threshold: 0 })
            : null;
          const watchTarget = (el) => {
            if (!visibility || !el || el.dataset.vtWatched) return;
            el.dataset.vtWatched = 'true';
            visibility.observe(el);
          };

          const scan = () => {
            document.querySelectorAll('.es-popup-button').forEach(watchTarget);
            watchTarget(document.querySelector('.site-footer'));
            const sticky = document.getElementById('es-sticky');
            if (sticky && !sticky.dataset.vtStyled) {
              sticky.dataset.vtStyled = 'true';
              apply(sticky);
              new MutationObserver(() => apply(sticky)).observe(sticky, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
              refresh();
            }
            this.styleEasySellForm();
          };
          scan();
          new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
        }

        // Fenêtre de commande EasySell : arrondis, bouton d’accent et ligne de réassurance
        styleEasySellForm() {
          const container = document.getElementById('es-form-container');
          if (!container) return;
          const set = (el, property, value) => {
            if (el.style.getPropertyValue(property) !== value || el.style.getPropertyPriority(property) !== 'important') {
              el.style.setProperty(property, value, 'important');
            }
          };
          set(container, 'border-radius', '20px');
          container.querySelectorAll('.close-icon i, .close-icon svg').forEach((icon) => set(icon, 'color', '#fff'));
          const button = document.getElementById('es-form-button');
          if (button) {
            set(button, 'background-color', 'var(--color-button)');
            set(button, 'color', 'var(--color-on-accent)');
            set(button, 'border-radius', 'var(--style-border-radius-buttons)');
            button.querySelectorAll('span, i').forEach((el) => {
              if (!el.classList.contains('es-loading-mask')) set(el, 'color', 'var(--color-on-accent)');
            });
            button.classList.add('vt-es');
            if (!button.dataset.vtStyled) {
              button.dataset.vtStyled = 'true';
              new MutationObserver(() => this.styleEasySellForm()).observe(button, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
            }
            if (!container.querySelector('.vt-es-assurance')) {
              const list = document.createElement('ul');
              list.className = 'vt-es-assurance';
              list.setAttribute('role', 'list');
              (this.dataset.esAssurance || '').split('|').filter(Boolean).forEach((text) => {
                const item = document.createElement('li');
                item.textContent = text;
                list.appendChild(item);
              });
              button.insertAdjacentElement('afterend', list);
            }
          }
        }

        // ---------- EasySell ----------
        // Quand l'application EasySell insère son bouton, on lui applique le style
        // VOLTEO, on masque le bouton du thème, et la barre fixe ouvre EasySell.
        watchEasySell() {
          const found = () => this.querySelector('#es-popup-button') || document.getElementById('es-popup-button');
          const ready = (button) => {
            if (this.esButton === button) return;
            this.esButton = button;
            this.styleEasySell(button);
            this.classList.add('has-easysell');
            // L'application peut réécrire son style : on le réapplique si besoin
            new MutationObserver(() => this.styleEasySell(button)).observe(button, { attributes: true, attributeFilter: ['style'] });
            // La barre fixe suit désormais le bouton EasySell
            if (this.barObserver) {
              this.barObserver.unobserve(this.mainButton);
              this.barVisible.delete(this.mainButton);
              this.barObserver.observe(button);
            }
          };
          const existing = found();
          if (existing) {
            ready(existing);
          } else {
            const observer = new MutationObserver(() => {
              const button = found();
              if (button) {
                observer.disconnect();
                ready(button);
              }
            });
            observer.observe(document.body, { childList: true, subtree: true });
            setTimeout(() => observer.disconnect(), 20000);
          }
          // Barre fixe : ouvre le formulaire EasySell s'il est présent
          if (this.stickyBar) {
            this.stickyBar.addEventListener('click', (event) => {
              if (!this.esButton || !event.target.closest('[data-submit]')) return;
              event.preventDefault();
              this.esButton.click();
            });
          }
        }

        styleEasySell(button) {
          const wanted = {
            background: 'var(--color-button)',
            color: 'var(--color-on-accent)',
            'border-radius': 'var(--style-border-radius-buttons)',
            'border-width': '0px',
            'font-weight': '700',
          };
          Object.entries(wanted).forEach(([property, value]) => {
            if (button.style.getPropertyValue(property) !== value || button.style.getPropertyPriority(property) !== 'important') {
              button.style.setProperty(property, value, 'important');
            }
          });
          button.classList.add('vt-es');
        }

        stepQuantity(step) {
          if (!this.quantity) return;
          const max = parseInt(this.quantity.max, 10);
          let value = (parseInt(this.quantity.value, 10) || 1) + step;
          value = Math.max(1, value);
          if (!Number.isNaN(max)) value = Math.min(max, value);
          this.quantity.value = value;
        }

        // Le formulaire n'arrive ici qu'après la validation du navigateur
        // (case de déclaration cochée, quantité valide).
        onSubmit(event) {
          if (this.submitting) {
            event.preventDefault();
            return;
          }
          // Sans fetch : envoi classique du formulaire Shopify
          if (!window.fetch || !window.FormData) {
            this.submitting = true;
            return;
          }
          event.preventDefault();
          this.addToCart();
        }

        async addToCart() {
          this.submitting = true;
          this.hideError();
          this.setBusy(true);
          try {
            const buyNow = this.dataset.action === 'checkout';
            // Commande directe : le panier ne contient que ce produit
            if (buyNow && this.dataset.replaceCart === 'true') {
              await fetch(`${this.dataset.cartClearUrl}.js`, {
                method: 'POST',
                headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              });
            }
            const body = new FormData(this.form);
            body.delete('return_to');
            const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body,
            });
            if (response.ok) {
              window.location.href = buyNow ? this.dataset.checkoutUrl : this.dataset.cartUrl;
              return;
            }
            let detail = '';
            try {
              const data = await response.json();
              detail = data.description || data.message || '';
            } catch (error) {
              detail = '';
            }
            this.showError(this.dataset.errorGeneric, detail);
          } catch (error) {
            this.showError(this.dataset.errorNetwork, '');
          }
          this.setBusy(false);
          this.submitting = false;
        }

        setBusy(busy) {
          this.submitButtons.forEach((button) => {
            if (busy) {
              button.dataset.previousLabel = button.textContent;
              button.textContent = this.dataset.labelAdding;
              button.setAttribute('aria-disabled', 'true');
            } else {
              if (button.dataset.previousLabel) button.textContent = button.dataset.previousLabel;
              button.removeAttribute('aria-disabled');
            }
          });
        }

        showError(message, detail) {
          if (!this.errorBox) return;
          this.errorBox.textContent = detail ? `${message} ${detail}` : message;
          this.errorBox.hidden = false;
          // Sur mobile, ramène le message à l'écran s'il a été déclenché depuis la barre fixe
          this.errorBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }

        hideError() {
          if (!this.errorBox) return;
          this.errorBox.hidden = true;
          this.errorBox.textContent = '';
        }

        // La barre fixe apparaît dès que le bouton principal n'est pas visible à l'écran
        setupStickyBar() {
          const mainButton = this.querySelector('.product__submit');
          if (!this.stickyBar || !mainButton || !('IntersectionObserver' in window)) return;
          // La barre est masquée tant que le bouton principal, l'appel final
          // (« Offre sécurité ») ou le pied de page sont visibles à l'écran.
          const targets = [mainButton, document.querySelector('.cta-final'), document.querySelector('.site-footer')].filter(Boolean);
          const visible = new Set();
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) visible.add(entry.target);
                else visible.delete(entry.target);
              });
              this.stickyBar.hidden = visible.size > 0;
            },
            { threshold: 0 }
          );
          targets.forEach((target) => observer.observe(target));
          this.mainButton = mainButton;
          this.barObserver = observer;
          this.barVisible = visible;
        }

        onVariantChange() {
          const option = this.select.selectedOptions[0];
          if (!option) return;
          const available = option.dataset.available === 'true';
          this.hideError();

          this.querySelectorAll('[data-price], [data-bar-price]').forEach((el) => {
            el.textContent = option.dataset.price;
          });

          const compare = this.querySelector('[data-compare]');
          if (option.dataset.compare) {
            compare.querySelector('[data-compare-value]').textContent = option.dataset.compare;
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }

          const badge = this.querySelector('[data-discount]');
          badge.textContent = option.dataset.discount;
          badge.hidden = !option.dataset.discount;

          const savings = this.querySelector('[data-savings]');
          savings.textContent = option.dataset.savings;
          savings.hidden = !option.dataset.savings || this.dataset.showSavings === 'false';

          const stock = this.querySelector('[data-stock]');
          stock.classList.toggle('is-available', available);
          stock.classList.toggle('is-sold-out', !available);
          stock.querySelector('[data-stock-label]').textContent = option.dataset.stock;

          if (this.quantity) {
            if (option.dataset.max) {
              this.quantity.max = option.dataset.max;
              if (parseInt(this.quantity.value, 10) > parseInt(option.dataset.max, 10)) {
                this.quantity.value = option.dataset.max;
              }
            } else {
              this.quantity.removeAttribute('max');
            }
          }

          this.submitButtons.forEach((button) => {
            button.disabled = !available;
            button.textContent = available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
          });

          // Affiche l'image de la variante et met à jour l'URL (partage du lien)
          const gallery = document.querySelector('vt-product-gallery');
          if (gallery && option.dataset.media && typeof gallery.show === 'function') {
            gallery.show(option.dataset.media);
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url.toString());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-cta"] && !Shopify.designMode) return;
  try {
    
  // EasySell insère aussi son bouton dans ce formulaire : on lui donne le
  // style VOLTEO (accent, pilule, animations) et on masque le bouton du thème.
  (() => {
    const style = (button, form) => {
      const wanted = {
        background: 'var(--color-button)',
        color: 'var(--color-on-accent)',
        'border-radius': 'var(--style-border-radius-buttons)',
        'border-width': '0px',
        'font-weight': '700',
      };
      Object.entries(wanted).forEach(([property, value]) => {
        if (button.style.getPropertyValue(property) !== value || button.style.getPropertyPriority(property) !== 'important') {
          button.style.setProperty(property, value, 'important');
        }
      });
      button.classList.add('vt-es');
      form.classList.add('has-easysell');
    };
    const scan = () => {
      document.querySelectorAll('.cta-final__form').forEach((form) => {
        const button = form.querySelector('.es-popup-button');
        if (!button || button.dataset.vtStyled) return;
        button.dataset.vtStyled = 'true';
        style(button, form);
        new MutationObserver(() => style(button, form)).observe(button, { attributes: true, attributeFilter: ['style'] });
      });
    };
    const start = () => {
      scan();
      const observer = new MutationObserver(scan);
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 20000);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  // Sur la fiche produit : le bouton final déclenche le bouton principal,
  // pour une seule et même logique de commande (pas de second ajout).
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.cta-final__form');
    if (!form) return;
    // Formulaire EasySell s'il est installé, sinon le bouton principal du thème
    const easySell = document.getElementById('es-popup-button');
    if (easySell) {
      event.preventDefault();
      easySell.click();
      return;
    }
    const mainButton = document.querySelector('vt-product-form .product__submit');
    if (!mainButton || mainButton.disabled) return;
    event.preventDefault();
    mainButton.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-feature-rows"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('[data-frows]:not(.is-ready)').forEach((root) => {
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        root.classList.add('is-ready');
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15 }
        );
        root.querySelectorAll('.frow').forEach((row) => observer.observe(row));
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vt-gallery')) {
    customElements.define(
      'vt-gallery',
      class VtGallery extends HTMLElement {
        connectedCallback() {
          this.dialog = this.parentElement.querySelector('.gallery__dialog');
          if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
          this.dialogImg = this.dialog.querySelector('.gallery__dialog-img');
          this.addEventListener('click', (event) => {
            const button = event.target.closest('.gallery__zoom');
            if (!button) return;
            const img = button.querySelector('img');
            this.dialogImg.src = button.dataset.full;
            this.dialogImg.alt = img ? img.alt : '';
            this.dialog.showModal();
          });
          // Fermer en cliquant à côté de l'image
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
